import { render, staticRenderFns } from "./ExistingWillOverseasYN.vue?vue&type=template&id=1a147228"
import script from "./ExistingWillOverseasYN.vue?vue&type=script&lang=js"
export * from "./ExistingWillOverseasYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports